module.exports = __webpack_public_path__ + "img/horizontal_6_4_8003.f126a7a4.png";